// React
import React from 'react';
import { Col, Label, Row } from 'reactstrap';

// Containers Injections
import {
  Currency,
  SelectInput,
  convertEventSelectToTarget,
} from '../../../../containers/componentsInjection';

// Utils
import { createData } from '../../../../../../utils/createData';

export const PaymentInfo = ({
  isView,
  validation,
  sellersData,
  paymentMethodsData,
}) => {
  const dataPaymentType = [
    { value: 'M', label: 'Mensal' },
    { value: 'Y', label: 'Anual' },
  ];

  return (
    <Row>
      <Col md={4} className="mb-3">
        <Label
          for="sellerInput"
          className="text-muted text-uppercase fw-semibold"
        >
          Corretor
        </Label>
        <SelectInput
          value={validation.values.sellerInput}
          className="form-control bg-light border-0"
          isDisabled={isView}
          onChange={(eventInput) => {
            validation.handleChange(
              convertEventSelectToTarget('sellerInput', eventInput)
            );
          }}
          onBlur={(eventInput) => {
            validation.handleBlur(
              convertEventSelectToTarget('sellerInput', eventInput)
            );
          }}
          options={createData(sellersData)}
          inputId="sellerInput"
          invalid={
            !!(validation.touched.sellerInput && validation.errors.sellerInput)
          }
        />
      </Col>
      <Col md={2} className="mb-3">
        <Label
          for="priceInput"
          className="text-muted text-uppercase fw-semibold"
        >
          Preço
        </Label>
        <Currency
          className="form-control bg-light border-0"
          value={Number(validation.values.priceInput || 0)}
          disabled={isView}
          onChange={(_, eventInputWithoutMask) => {
            validation.handleChange(
              convertEventSelectToTarget('priceInput', eventInputWithoutMask)
            );
          }}
          onBlur={(_, eventInputWithoutMask) => {
            validation.handleBlur(
              convertEventSelectToTarget('priceInput', eventInputWithoutMask)
            );
          }}
          id="priceInput"
        />
      </Col>
      <Col md={3} className="mb-3">
        <Label
          for="billingName"
          className="text-muted text-uppercase fw-semibold"
        >
          Periodicidade de pagamento
        </Label>
        <SelectInput
          value={validation.values.paymentTypeInput}
          className="form-control bg-light border-0"
          isDisabled={isView}
          invalid={
            !!(
              validation.touched.paymentTypeInput &&
              validation.errors.paymentTypeInput
            )
          }
          onChange={(eventInput) => {
            validation.handleChange(
              convertEventSelectToTarget('paymentTypeInput', eventInput)
            );
          }}
          onBlur={(eventInput) => {
            validation.handleBlur(
              convertEventSelectToTarget('paymentTypeInput', eventInput)
            );
          }}
          options={dataPaymentType}
          inputId="paymentTypeInput"
        />
      </Col>
      <Col md={3} className="mb-3">
        <Label
          for="paymentFormInput"
          className="text-muted text-uppercase fw-semibold"
        >
          Condições de pagamento
        </Label>
        <SelectInput
          value={validation.values.paymentFormInput}
          className="form-control bg-light border-0"
          isClearable={false}
          isDisabled={isView}
          invalid={
            !!(
              validation.touched.paymentFormInput &&
              validation.errors.paymentFormInput
            )
          }
          onChange={(eventInput) => {
            validation.handleChange(
              convertEventSelectToTarget('paymentFormInput', eventInput)
            );
          }}
          onBlur={(eventInput) => {
            validation.handleBlur(
              convertEventSelectToTarget('paymentFormInput', eventInput)
            );
          }}
          options={paymentMethodsData}
          inputId="paymentFormInput"
        />
      </Col>
    </Row>
  );
};
